import isUndefined from 'lodash/isUndefined'
import { Component } from 'preact'
import Button from 'preact-material-components/Button'
import { withNamespaces } from 'react-i18next'
import Elevation from 'preact-material-components/Elevation'
import { email as emailValid, phoneNumber as phoneNumberValid, required } from '../../../utils'
import Input from '../../Input'
import TextArea from '../../TextArea'
import styles from './CustomerForm.scss'

class CustomerForm extends Component {
    defaultState = {
        name: '',
        phone: '',
        email: '',
        remarks: '',
        nameError: '',
        phoneError: '',
        emailError: ''
    }

    state = { ...this.defaultState }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleNameChange = e => {
        const nameError = required(e.target.value)
        this.setState({ name: e.target.value, nameError })
    }

    handleEmailChange = e => {
        const emailError = required(e.target.value) || emailValid(e.target.value)
        this.setState({ email: e.target.value, emailError })
    }

    handlePhoneChange = e => {
        const phoneError = required(e.target.value) || phoneNumberValid(e.target.value)
        this.setState({ phone: e.target.value, phoneError })
    }

    handleSubmit = () => {
        const { name, phone, email, remarks } = this.state
        this.props.onSubmit(name, phone, email, remarks)
        this.setState(this.defaultState)
    }

    componentWillUnmount() {
        this.setState(this.defaultState)
    }

    render(props, { nameError, emailError, phoneError, name, phone, email, remarks }) {
        const valid = isUndefined(nameError) && isUndefined(emailError) && isUndefined(phoneError)

        const { t } = this.props
        
        return (
            <Elevation class={styles.customerFormElevation} z={2}>
                <div className={styles.formField}>
                    <label className={styles.label}>
                        {t('CustomerForm.firstlastname')}<span class={styles.requiredAsterisk}>*</span>
                    </label>
                    <Input
                        autoFocus
                        value={name}
                        fullWidth
                        placeholder={t('CustomerForm.fullNamePlaceholder')}
                        className={styles.input}
                        label={t('CustomerForm.fullNameLabel')}
                        name="name"
                        onInput={this.handleNameChange}
                        error={!!nameError}
                        errorMessage={t(nameError)}
                    />
                </div>

                <div className={styles.formField}>
                    <label className={styles.label}>
                        {t('CustomerForm.emailLabel')}<span class={styles.requiredAsterisk}>*</span>
                    </label>
                    <Input
                        value={email}
                        fullWidth
                        placeholder={t('CustomerForm.emailPlaceholder')}
                        className={styles.input}
                        name="email"
                        onInput={this.handleEmailChange}
                        error={!!emailError}
                        errorMessage={t(emailError)}
                    />
                </div>

                <div className={styles.formField}>
                    <label className={styles.label}>
                        {t('CustomerForm.phoneLabel')}<span class={styles.requiredAsterisk}>*</span>
                    </label>
                    <Input
                        value={phone}
                        fullWidth
                        placeholder={t('CustomerForm.phonePlaceholder')}
                        className={styles.input}
                        name="phone"
                        onInput={this.handlePhoneChange}
                        error={!!phoneError}
                        errorMessage={t(phoneError)}
                    />
                </div>

                <div className={styles.formField}>
                    <label className={styles.label}>{t('CustomerForm.remarks')}</label>

                    <div className={styles.textAreaWrapper}>
                        <TextArea
                            value={remarks}
                            placeholder={t('CustomerForm.remarksPlaceholder')}
                            name="remarks"
                            onInput={this.handleChange}
                        />
                    </div>
                </div>

                <Button class={styles.submitButton} disabled={!valid} raised onClick={this.handleSubmit}>
                    {t('common.booknow')}
                </Button>
            </Elevation>
        )
    }
}

export default withNamespaces()(CustomerForm)


// WEBPACK FOOTER //
// ./components/CustomerInfoLayout/CustomerForm/CustomerForm.js